var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app d-flex flex-column" },
    [
      _c(
        "div",
        {
          staticClass:
            "body align-self-center d-flex flex-column justify-content-center align-items-center"
        },
        [
          _c("div", { staticClass: "logo-container" }, [
            _c("div", {
              staticClass: "signin-logo mb-4",
              domProps: { innerHTML: _vm._s(_vm.svg.logo) }
            })
          ]),
          _vm._v(" "),
          _c(
            "b-card",
            {
              staticClass:
                "p-4 mb-0 input-card d-flex flex-column align-items-stretch",
              attrs: { "no-body": "" }
            },
            [
              _c("b-card-body"),
              _vm._v(" "),
              _c(
                "b-row",
                { attrs: { "align-v": "center" } },
                [
                  _c(
                    "b-col",
                    { staticClass: "text-center", attrs: { cols: "12" } },
                    [
                      _c("span", { staticClass: "ms-label" }, [
                        _vm._v("Login with")
                      ]),
                      _vm._v(" "),
                      _c("b-img", {
                        attrs: {
                          src: "../../../static/img/microsoft.png",
                          fluid: "",
                          alt: "Fluid image"
                        },
                        on: { click: _vm.loginRedirect }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("Footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e0d6e88", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e0d6e88","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/Login.vue
// module id = 1026
// module chunks = 2